// extracted by mini-css-extract-plugin
export default {"rotate":"get-verify-code_rotate__XrPfu"};